import { Reveal, Eyebrow } from "../components/Reveal";

const STEPS = [
  { num: "01", name: "Understand", desc: "Detailed history, symptoms, lifestyle, previous investigations and treatment history." },
  { num: "02", name: "Map", desc: "Identify the important metabolic and lifestyle patterns." },
  { num: "03", name: "Prioritise", desc: "Not everything needs to be investigated or treated simultaneously." },
  { num: "04", name: "Personalise", desc: "Nutrition, movement, sleep, behavioural and, when appropriate, supplement strategies." },
  { num: "05", name: "Measure", desc: "Track meaningful outcomes and adjust the plan over time." },
  { num: "06", name: "Sustain", desc: "The objective isn't a six-week protocol. It's a healthier way of living that you can actually maintain." },
];

export const Approach = () => (
  <section id="approach" className="bg-white" data-testid="approach-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
        <Reveal className="lg:col-span-6">
          <Eyebrow>03 · The InSight Approach</Eyebrow>
          <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Look beyond the isolated number.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6 lg:self-end">
          <p className="text-inkmuted leading-relaxed max-w-lg lg:ml-auto">
            We look for patterns, relationships and modifiable contributors that may be missed when health is
            viewed one symptom or one laboratory value at a time.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={0.07 * i}>
            <div className="border-t-2 border-gold/50 pt-7 group" data-testid={`approach-step-${s.num}`}>
              <span className="font-mono text-4xl text-forest/15 group-hover:text-gold transition-colors duration-500">
                {s.num}
              </span>
              <h3 className="mt-4 font-serif text-2xl text-ink tracking-tight">{s.name}</h3>
              <p className="mt-3 text-sm text-inkmuted leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
